import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVenmo = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "uuid-fb5e001e-436b-458b-aeab-8d888c450fd4",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 116.18 116.18",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "uuid-20cadca3-65c6-416a-a407-4f8a9648f17f",
		"data-name": "layer11",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "uuid-38f9c247-475f-4c92-942c-65e35166a34a",
			"data-name": "g8381",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "uuid-c8e12fd2-ee8d-41e4-b9e8-de3571d31660",
					"data-name": "path8151",
					fill: "currentColor",
					d: "M28.79,49.34c.6.96.88,1.98.88,3.24,0,4.02-3.56,9.27-6.44,12.93h-6.6l-2.65-15.28,5.77-.52,1.41,10.87c1.31-2.06,2.93-5.3,2.93-7.5s-.21-2.03-.56-2.7l5.26-1.03h0Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "uuid-22270536-b5bf-473d-b0e8-ad9122b9c563",
					"data-name": "path8171",
					fill: "currentColor",
					d: "M36.27,56.08c1.06,0,3.74-.47,3.74-1.94s-.52-1.06-1.13-1.06c-1.06,0-2.47,1.23-2.61,2.99v.02ZM36.16,58.98c0,1.8,1.03,2.5,2.4,2.5s2.93-.36,4.77-1.26l-.7,4.58c-1.31.62-3.35,1.03-5.33,1.03-5.02,0-6.82-2.94-6.82-6.62s2.93-9.82,8.94-9.82,5.16,1.8,5.16,4.3c0,4.02-5.34,5.26-8.45,5.3h.02Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "uuid-ad95fbb6-de99-42ad-9197-74819c9c3638",
					"data-name": "path8191",
					fill: "currentColor",
					d: "M61.28,52.87c0,.59-.1,1.44-.18,1.99l-1.73,10.57h-5.62l1.59-9.69c.03-.26.11-.8.11-1.08,0-.7-.46-.88-1-.88s-1.45.33-1.94.56l-1.8,11.11h-5.65l2.58-15.84h4.9l.07,1.26c1.16-.74,2.68-1.54,4.84-1.54,2.86,0,3.86,1.41,3.86,3.53h-.02Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "uuid-05776889-79c1-45b1-85ef-72fac7aaa61d",
					"data-name": "path8211",
					fill: "currentColor",
					d: "M77.98,51.14c1.62-1.11,3.14-1.73,5.23-1.73s3.89,1.41,3.89,3.53-.1,1.44-.18,1.99l-1.73,10.57h-5.62l1.62-9.9c.03-.26.1-.59.1-.78,0-.8-.46-.96-1.01-.96s-1.39.29-1.91.56l-1.8,11.11h-5.62l1.62-9.9c.03-.26.1-.59.1-.78,0-.8-.46-.96-1-.96s-1.45.33-1.94.56l-1.8,11.11h-5.65l2.58-15.84h4.84l.15,1.32c1.13-.78,2.65-1.59,4.67-1.59,1.77,0,2.93.74,3.5,1.73l-.02-.03Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "uuid-ccdfad97-c95a-482f-b297-bfd87e3184d6",
					"data-name": "path8231",
					fill: "currentColor",
					d: "M98.3,55.75c0-1.29-.33-2.17-1.34-2.17-2.22,0-2.68,3.79-2.68,5.74s.42,2.39,1.42,2.39c2.09,0,2.58-4,2.58-5.93l.02-.02ZM88.57,59.07c0-5,2.73-9.68,9.04-9.68s6.47,2.7,6.47,6.44-2.71,10.05-9.15,10.05-6.36-3.02-6.36-6.82Z"
				})
			]
		})
	})
});
export default SvgVenmo;
